<!--
 * @Autor: liuzilei3
 * @Email: liuzilei3@jd.com
 * @Description: 
 * @CreateDate: Do not edit
 * @LastEditors: liuzilei3
-->
<template>
  <component
    :is="componentMap[type]"
    v-model="modelValue"
    :role="roleMap[type]"
    :class="ns.b('group')"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { computed, nextTick, provide } from 'vue'
import { UPDATE_MODEL_EVENT } from '@jdesign-vue/constants'
import { JdCheckboxGroup } from '@jdesign-vue/components/checkbox'
import { JdRadioGroup } from '@jdesign-vue/components/radio'
import { useNamespace } from '@jdesign-vue/hooks'
import { statisticGroupContextKey } from './constants'
import { statisticGroupEmits, statisticGroupProps } from './statistic-group'

defineOptions({
  name: 'JdStatisticGroup',
})

const props = defineProps(statisticGroupProps)
const emit = defineEmits(statisticGroupEmits)

const ns = useNamespace('statistic')

const componentMap = {
  '': 'div',
  radio: JdRadioGroup,
  checkbox: JdCheckboxGroup,
} as const

const roleMap = {
  '': '',
  radio: 'radiogroup',
  checkbox: 'group',
} as const

const changeEvent = (value: any) => {
  emit(UPDATE_MODEL_EVENT, value)
  nextTick(() => {
    emit('change', value)
  })
}

const modelValue: any = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    changeEvent(val)
  },
})

provide(statisticGroupContextKey, {
  type: props.type,
  size: props.size,
  changeEvent,
  modelValue,
})
</script>
